import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stacked-table',
  templateUrl: './stacked-table.component.html',
  styleUrls: ['./stacked-table.component.scss']
})
export class StackedTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
